import type { IProjectService } from "./IProjectService";
import type { ApiProject, ApiReturnProject } from "@highimpact-frontend/api-types";
import { api_config } from "../../../api-commons";


class ProjectService implements IProjectService {
    getProjects(user_is_admin_only?: boolean): Promise<ApiReturnProject[]> {
        const response = api_config.get(`/projects${user_is_admin_only ? '?user_is_admin_only=true' : ''}`);
        return response.then(res => res.data);
    }
    // getProject(id: number): Promise<ApiReturnProject> {
    //     throw new Error("Method not implemented.");
    // }
    async add(params: ApiProject): Promise<ApiReturnProject> {
        const response = await api_config.post('/projects', params);
        return response.data;
    }
    async update(id: number, params: ApiProject): Promise<ApiReturnProject> {
        const response = await api_config.put(`/projects/${id}`, params);
        return response.data;
    }

    async delete(id: number): Promise<ApiReturnProject> {
        const response = await api_config.delete(`/projects/${id}`);
        return response.data;
    }

}

const instance = new ProjectService();
export default instance;